export enum EntityType {
  OXIO = 'oxio',
  PAYMENT_CHANNEL = 'payment-channel',
  BRAND = 'brand',
  DISTRIBUTOR = 'distributor',
}
